import React, { useState, useEffect } from 'react';
import {
  courses as initialCourses,
  instructors as initialInstructors,
  projects as initialProjects
} from '../data';
import './index.css';
import './admin.css';

const Admin = () => {
  const [courses, setCourses] = useState(initialCourses);
  const [instructors, setInstructors] = useState(initialInstructors);
  const [projects, setProjects] = useState(initialProjects);
  const [students, setStudents] = useState([]);

  const [newCourse, setNewCourse] = useState({ title: '', image: '', description: '' });
  const [newInstructor, setNewInstructor] = useState({ name: '', title: '', image: '', bio: '' });
  const [newProject, setNewProject] = useState({ title: '', image: '', description: '' });

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const response = await fetch('https://techwala-api-production.up.railway.app/students');
        const data = await response.json();
        setStudents(data);
      } catch (error) {
        console.error('Error fetching students:', error);
      }
    };

    fetchStudents();
  }, []);

  const handleAdd = (type, item) => {
    if (type === 'course') setCourses([...courses, item]);
    if (type === 'instructor') setInstructors([...instructors, item]);
    if (type === 'project') setProjects([...projects, item]);
  };

  const handleDelete = (type, index) => {
    if (type === 'course') setCourses(courses.filter((_, i) => i !== index));
    if (type === 'instructor') setInstructors(instructors.filter((_, i) => i !== index));
    if (type === 'project') setProjects(projects.filter((_, i) => i !== index));
  };

  return (
    <div className="admin">
      <h2>Admin Dashboard</h2>

      {/* Courses Section */}
      <section>
        <h3>Courses</h3>
        <div className="cards-grid">
          {courses.map((course, i) => (
            <div className="card" key={i}>
              <img src={course.image} alt={course.title} />
              <div className="card-content">
                <h3>{course.title}</h3>
                <p>{course.description}</p>
                <button onClick={() => handleDelete('course', i)}>Delete</button>
              </div>
            </div>
          ))}
        </div>
        <form
          onSubmit={e => {
            e.preventDefault();
            handleAdd('course', newCourse);
            setNewCourse({ title: '', image: '', description: '' });
          }}
        >
          <input placeholder="Title" value={newCourse.title} onChange={e => setNewCourse({ ...newCourse, title: e.target.value })} />
          <input placeholder="Image URL" value={newCourse.image} onChange={e => setNewCourse({ ...newCourse, image: e.target.value })} />
          <textarea placeholder="Description" value={newCourse.description} onChange={e => setNewCourse({ ...newCourse, description: e.target.value })} />
          <button type="submit">Add Course</button>
        </form>
      </section>

      {/* Instructors Section */}
      <section>
        <h3>Instructors</h3>
        <div className="cards-grid">
          {instructors.map((inst, i) => (
            <div className="card" key={i}>
              <img src={inst.image} alt={inst.name} />
              <div className="card-content">
                <h3>{inst.name}</h3>
                <p>{inst.title}</p>
                <button onClick={() => handleDelete('instructor', i)}>Delete</button>
              </div>
            </div>
          ))}
        </div>
        <form
          onSubmit={e => {
            e.preventDefault();
            handleAdd('instructor', newInstructor);
            setNewInstructor({ name: '', title: '', image: '', bio: '' });
          }}
        >
          <input
            placeholder="Name"
            value={newInstructor.name}
            onChange={e => setNewInstructor({ ...newInstructor, name: e.target.value })}
          />
          <input
            placeholder="Title"
            value={newInstructor.title}
            onChange={e => setNewInstructor({ ...newInstructor, title: e.target.value })}
          />
          <select
            value={newInstructor.image}
            onChange={e => setNewInstructor({ ...newInstructor, image: e.target.value })}
          >
            <option value="">Select Photo</option>
            <option value="../Photos/sm.jpg.jpeg">Sofikul Mallick</option>
            <option value="../Photos/nil.jgp.jpeg">Nilmoni Pal</option>
            <option value="../Photos/md.jpg.jpeg">Md Mainuddin</option>
          </select>
          <textarea
            placeholder="Bio"
            value={newInstructor.bio}
            onChange={e => setNewInstructor({ ...newInstructor, bio: e.target.value })}
          />
          <button type="submit">Add Instructor</button>
        </form>
      </section>

      {/* Projects Section */}
      <section>
        <h3>Projects</h3>
        <div className="cards-grid">
          {projects.map((proj, i) => (
            <div className="card" key={i}>
              <img src={proj.image} alt={proj.title} />
              <div className="card-content">
                <h3>{proj.title}</h3>
                <p>{proj.description}</p>
                <button onClick={() => handleDelete('project', i)}>Delete</button>
              </div>
            </div>
          ))}
        </div>
        <form
          onSubmit={e => {
            e.preventDefault();
            handleAdd('project', newProject);
            setNewProject({ title: '', image: '', description: '' });
          }}
        >
          <input placeholder="Title" value={newProject.title} onChange={e => setNewProject({ ...newProject, title: e.target.value })} />
          <input placeholder="Image URL" value={newProject.image} onChange={e => setNewProject({ ...newProject, image: e.target.value })} />
          <textarea placeholder="Description" value={newProject.description} onChange={e => setNewProject({ ...newProject, description: e.target.value })} />
          <button type="submit">Add Project</button>
        </form>
      </section>

      {/* Students Section */}
      <section>
        <h3>Registered Students</h3>
        {students.length === 0 ? (
          <p>No students registered yet.</p>
        ) : (
          <div className="students-table-wrapper">
            <table className="students-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Qualification</th>
                  <th>City</th>
                  <th>Image</th>
                </tr>
              </thead>
              <tbody>
                {students.map((s) => (
                  <tr key={s.id}>
                    <td>{s.id}</td>
                    <td>{s.name}</td>
                    <td>{s.email}</td>
                    <td>{s.mobileNumber}</td>
                    <td>{s.highestQualification}</td>
                    <td>{s.city}</td>
                    <td>
                      {s.imageUrl ? <img src={s.imageUrl} alt={s.name} width="40" height="40" /> : 'N/A'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
};

export default Admin;
